      

        // Basic JavaScript for slide transitio'ns
        document.addEventListener('DOMContentLoaded', () => {
            const carousel = document.querySelector('.slideshow-carousel');
            const slides = carousel.querySelectorAll('.slideshow__slide');
            const dots = carousel.querySelectorAll('.page-dots button');
            let currentSlide = 0;
            let interval;

            function showSlide(index) {
                slides.forEach(slide => slide.classList.remove('is-selected'));
                dots.forEach(dot => dot.setAttribute('aria-current', 'false'));
                
                slides[index].classList.add('is-selected');
                dots[index].setAttribute('aria-current', 'true');
            }

            function nextSlide() {
                currentSlide = (currentSlide + 1) % slides.length;
                showSlide(currentSlide);
            }

            dots.forEach((dot, index) => {
                dot.addEventListener('click', () => {
                    currentSlide = index;
                    showSlide(currentSlide);
                    clearInterval(interval);
                    interval = setInterval(nextSlide, 5000);
                });
            });

            // Auto advance slides
            interval = setInterval(nextSlide, 5000);
        });
       
        document.addEventListener("DOMContentLoaded", () => {
  const tabButtons = document.querySelectorAll(".tab-btn-uni");
  const productGrids = document.querySelectorAll(".products-grid-uni");

  const initializeCarousel = (container) => {
    const wrapper = container.querySelector(".products-wrapper-uni");
    const prevBtn = container.querySelector(".prev-btn-uni");
    const nextBtn = container.querySelector(".next-btn-uni");
    const cards = container.querySelectorAll(".product-card-uni");
    const dotsContainer = container.querySelector(".carousel-dots-uni");

    if (!cards.length) return;

    // Fixed values
    const itemsPerView = 4;
    const totalSlides = Math.ceil(cards.length / itemsPerView);
    let currentSlide = 0;

    // Calculate single slide width
    const slideWidth = wrapper.offsetWidth;

    // Clear existing dots
    dotsContainer.innerHTML = '';

    // Create dots
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement("button");
      dot.classList.add("dot-uni");
      if (i === 0) dot.classList.add("active-uni");
      dot.addEventListener("click", () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }

    function updateCarousel() {
      // Update wrapper position
      wrapper.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
      
      // Update dots
      const dots = dotsContainer.querySelectorAll(".dot-uni");
      dots.forEach((dot, index) => {
        dot.classList.toggle("active-uni", index === currentSlide);
      });

      // Update buttons
      if (prevBtn) prevBtn.style.display = currentSlide === 0 ? "none" : "block";
      if (nextBtn) nextBtn.style.display = currentSlide >= totalSlides - 1 ? "none" : "block";
    }

    function goToSlide(slideIndex) {
      currentSlide = slideIndex;
      updateCarousel();
    }

    function nextSlide() {
      if (currentSlide < totalSlides - 1) {
        currentSlide++;
        updateCarousel();
      }
    }

    function prevSlide() {
      if (currentSlide > 0) {
        currentSlide--;
        updateCarousel();
      }
    }

    // Add button event listeners
    if (prevBtn) prevBtn.addEventListener("click", prevSlide);
    if (nextBtn) nextBtn.addEventListener("click", nextSlide);

    // Initial setup
    updateCarousel();

    // Handle resize
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 768) {
        wrapper.style.transform = 'none';
      } else {
        updateCarousel();
      }
    });
  };

  // Tab switching function
  function switchTab(targetTab) {
    tabButtons.forEach(btn => {
      btn.classList.toggle("active-btn-uni", btn.getAttribute("data-target") === targetTab);
    });

    productGrids.forEach(grid => {
      const isTargetGrid = grid.classList.contains(targetTab + "-uni");
      grid.classList.toggle("active-uni", isTargetGrid);
      if (isTargetGrid && window.innerWidth > 768) {
        initializeCarousel(grid);
      }
    });
  }

  // Add click handlers to tab buttons
  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      const target = button.getAttribute("data-target");
      switchTab(target);
    });
  });

  // Initialize active tab carousel
  const activeGrid = document.querySelector(".products-grid-uni.active-uni");
  if (activeGrid && window.innerWidth > 768) {
    initializeCarousel(activeGrid);
  }
});


document.addEventListener('DOMContentLoaded', () => {
    const categoryButtons = document.querySelectorAll('.category-btn-3');
    const allProducts = document.querySelectorAll('.product-card-3');

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        // Remove 'active-3' class from all buttons
        document.querySelector('.category-btn-3.active-3')?.classList.remove('active-3');
        button.classList.add('active-3');

        // Get selected category
        const category = button.getAttribute('data-category');

        // Show/hide products based on the selected category
        allProducts.forEach((product) => {
          if (category === 'all' || product.classList.contains(`category-${category}`)) {
            product.classList.add('visible');
          } else {
            product.classList.remove('visible');
          }
        });
      });
    });

    // Trigger the first category by default
    document.querySelector('.category-btn-3.active-3').click();
  });
  document.addEventListener('DOMContentLoaded', function() {
  // Tab switching
  const tabs = document.querySelectorAll('.tab-btn');
  const grids = document.querySelectorAll('.products-grid');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Remove active class from all tabs and grids
      tabs.forEach(t => t.classList.remove('active'));
      grids.forEach(g => g.classList.remove('active'));

      // Add active class to clicked tab and corresponding grid
      tab.classList.add('active');
      const gridClass = tab.getAttribute('data-tab');
      document.querySelector(`.products-grid.${gridClass}`).classList.add('active');

      // Initialize carousel for new active grid
      initializeCarousel(document.querySelector(`.products-grid.${gridClass}`));
    });
  });

  function initializeCarousel(grid) {
    if (window.innerWidth <= 768) return;

    const wrapper = grid.querySelector('.products-wrapper');
    const cards = wrapper.querySelectorAll('.product-card');
    const prevBtn = grid.querySelector('.prev');
    const nextBtn = grid.querySelector('.next');
    const dotsContainer = grid.querySelector('.dots');
    
    const cardsPerView = 4;
    const totalSlides = Math.ceil(cards.length / cardsPerView);
    let currentSlide = 0;

    // Create dots
    dotsContainer.innerHTML = '';
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('button');
      dot.classList.add('dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }

    function updateCarousel() {
      const slideWidth = cards[0].offsetWidth * cardsPerView + (cardsPerView - 1) * 20; // Including gap
      wrapper.style.transform = `translateX(-${currentSlide * slideWidth}px)`;

      // Update dots
      const dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach((dot, index) => dot.classList.toggle('active', index === currentSlide));

      // Update buttons
      prevBtn.style.display = currentSlide === 0 ? 'none' : 'block';
      nextBtn.style.display = currentSlide >= totalSlides - 1 ? 'none' : 'block';
    }

    function goToSlide(index) {
      currentSlide = index;
      updateCarousel();
    }

    prevBtn.addEventListener('click', () => {
      if (currentSlide > 0) {
        currentSlide--;
        updateCarousel();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (currentSlide < totalSlides - 1) {
        currentSlide++;
        updateCarousel();
      }
    });

    // Initial setup
    updateCarousel();

    // Reset on window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 768) {
        wrapper.style.transform = 'none';
      } else {
        currentSlide = 0;
        updateCarousel();
      }
    });
  }

  // Initialize carousel for initial active grid
  initializeCarousel(document.querySelector('.products-grid.active'));
});

(function() {
  if (document.getElementById('custom-toast')) return;

  const toastStyle = document.createElement('style');
  toastStyle.textContent = `
    #custom-toast {
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #843C1F;
      color: white;
      padding: 15px;
      border-radius: 5px;
      z-index: 1000;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      font-family: Arial, sans-serif;
      white-space: nowrap;
    }
    
    #custom-toast.show {
      opacity: 1;
    }
  `;
  document.head.appendChild(toastStyle);

  const toast = document.createElement('div');
  toast.id = 'custom-toast';
  toast.textContent = 'Product Added to Cart!';
  document.body.appendChild(toast);

  function showToast() {
    console.log("Toast triggered");
    toast.classList.add('show');
    setTimeout(() => {
      toast.classList.remove('show');
    }, 2000);
  }

  function attachToastListener() {
    // Expanded selectors to catch more buttons
    const addToCartButtons = document.querySelectorAll([
      '[id$="-submit"][type="submit"]', 
      '.product-form__submit',
      '.quick-add-modal .button'
    ].join(','));

    console.log(`Found ${addToCartButtons.length} add to cart buttons`);

    addToCartButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        // Detailed logging for debugging
        console.log('Button clicked:', button);

        // More comprehensive checks
        const isModalOpener = button.closest('modal-opener') !== null;
        const isDirectAddToCart = button.closest('.product-form') !== null;
        const isQuickAddModal = button.closest('.quick-add-modal') !== null;
        const isInCartAddForm = button.closest('form[action="/cart/add"]') !== null;

        // Detailed logging of button context
        console.log('Button Context:', {
          isModalOpener,
          isDirectAddToCart,
          isQuickAddModal,
          isInCartAddForm,
          isDisabled: button.disabled
        });

        // Improved condition for showing toast
        const shouldShowToast = 
          (!isModalOpener && (isDirectAddToCart || isInCartAddForm)) || 
          isQuickAddModal;

        if (shouldShowToast && !button.disabled) {
          console.log('Conditions met for toast');
          setTimeout(showToast, 500);
        } else {
          console.log('Toast conditions not met');
        }
      });
    });
  }

  // Try multiple methods to ensure listeners are attached
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachToastListener);
  } else {
    attachToastListener();
  }

  // Additional fallback for dynamic content
  const observer = new MutationObserver((mutations) => {
    attachToastListener();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());
